import { JsonObject, JsonProperty } from 'typescript-json-serializer';
import { ChargingStatistics } from './charging-statistics-model';
import { StatisticsPeriod } from './statistics-period.model';

@JsonObject()
export class StationId {
  @JsonProperty('Value') value: string;
}

@JsonObject()
export class StationChargingStatistics extends ChargingStatistics {
  @JsonProperty('StationId') stationId: StationId;
  @JsonProperty('StationName') stationName: string;
  @JsonProperty('Period') period: StatisticsPeriod;
  @JsonProperty({ name: 'ByDay', type: ChargingStatistics }) byDay: Array<ChargingStatistics>;
}
